import { ReactNode } from 'react'
import { Spinner } from '../../_ui'

type PropTypes = {
  title: string
  description: string
  emptyText: string
  loading: boolean
  isEmpty: boolean
  children: ReactNode
}

export const FestivalSection = ({ title, description, emptyText, loading, isEmpty, children }: PropTypes) => {
  return (
    <section className={'mt-14 first:mt-0'}>
      <h2 className={'text-2xl font-bold tracking-tight text-primary-200'}>
        {title}
      </h2>
      <p className={'mt-1 mb-6 text-sm text-gray-600'}>
        {description}
      </p>
      {loading && <Spinner />}
      {!loading && isEmpty && (
        <p className={'rounded-2xl border border-dashed border-sand-200 bg-white/60 px-5 py-8 text-center text-sm text-gray-600'}>
          {emptyText}
        </p>
      )}
      <div className={'grid gap-6 sm:grid-cols-2 lg:grid-cols-3'}>
        {children}
      </div>
    </section>
  )
}
